import React, { useState, useEffect } from 'react';
import ClockIcon from '../icons/ClockIcon';

interface BuffetTimerProps {
  endTime: number;
  className?: string;
}

const BuffetTimer: React.FC<BuffetTimerProps> = ({ endTime, className = '' }) => {
  const [timeRemaining, setTimeRemaining] = useState<number>(0);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const updateTimer = () => {
      const now = Date.now();
      const remaining = endTime - now;
      
      if (remaining <= 0) {
        setTimeRemaining(0);
        setIsExpired(true);
      } else {
        setTimeRemaining(remaining);
        setIsExpired(false);
      }
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [endTime]);

  const minutes = Math.floor(timeRemaining / 60000);
  const seconds = Math.floor((timeRemaining % 60000) / 1000);
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

  // Determine color based on time remaining
  let timerColor = 'text-gray-600';
  let bgColor = 'bg-gray-100';
  if (isExpired) {
    timerColor = 'text-red-700';
    bgColor = 'bg-red-100';
  } else if (minutes < 10) {
    timerColor = minutes < 5 ? 'text-red-600' : 'text-yellow-600';
    bgColor = minutes < 5 ? 'bg-red-100' : 'bg-yellow-100';
  }

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <ClockIcon className={`w-4 h-4 ${timerColor}`} />
      <span className={`text-xs font-semibold px-2 py-1 rounded ${bgColor} ${timerColor}`}>
        {isExpired ? 'EXPIRED' : formattedTime}
      </span>
    </div>
  );
};

export default BuffetTimer;

